const ACTIONS = {
  FETCH_ENERGY_CONSUMPTION_INIT: "FETCH_ENERGY_CONSUMPTION_INIT",
  FETCH_ENERGY_CONSUMPTION_SUCCESS: "FETCH_ENERGY_CONSUMPTION_SUCCESS",
  FETCH_ENERGY_CONSUMPTION_FAILURE: "FETCH_ENERGY_CONSUMPTION_FAILURE",
};

export default ACTIONS;
